import api from "./core";

const basePath = "api/core/Users";

export default {
  getSupervisionChartUsers(filter, data = {}) {
    return api.post(`${basePath}/GetSupervisionChartUsers`, filter, data);
  },
  setSupervisor(data) {
    return api.patch(`${basePath}/SetSupervisor`, data);
  },
  removeSupervisor(id) {
    return api.delete(`${basePath}/RemoveSupervisor/${id}`);
  }
};
